export const generateYearOptions = (startYear, endYear) => {
    return Array.from({ length: startYear - endYear + 1 }, (_, i) => {
      const year = String(startYear - i);
      return { value: year, label: year };
    });
};